import {useState, useEffect} from 'react';

import {Grid} from '@mui/material';
import ProductEditForm from 'components/product/ProductEditForm';

export default function AddproductActionImpl(){

    return (
        <>
        <ProductEditForm/>
        </>
    )
}